import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { Button } from '@app/components';
import colors from '@app/constants/colors';
import RouterConstants from '@app/constants/router';
import { resetUserOptions } from '@app/actions/subscribeActions';

class SuccessfulSignUp extends React.Component {
  componentWillUnmount() {
    const { resetUserOptions } = this.props;
    resetUserOptions();
  }

  render() {
    return (
      <SuccessfulSignUpContainer>
        <h2><FormattedMessage id="signUp.confirmation.accountCreated" /></h2>
        <GradientBlock>
          <CheckEmailHeader><FormattedMessage id="signUp.confirmation.checkMail" /></CheckEmailHeader>
          <Button
            path={RouterConstants.HOME}
            labelId="signUp.confirmation.gotIt"
            textColor={colors.ALICE_BLUE}
            backgroundColor={colors.INTERNATIONAL_ORANGE}
          />
        </GradientBlock>
      </SuccessfulSignUpContainer>
    );
  }
}

SuccessfulSignUp.propTypes = {
  resetUserOptions: PropTypes.func.isRequired,
};

export default connect(null, { resetUserOptions })(SuccessfulSignUp);

const SuccessfulSignUpContainer = styled.div`
  width: 100%;
  text-align: center;
  padding: 50px 0;
  
  @media (max-width: 979px) {
    padding: 40px 0;
  }  
`;

const GradientBlock = styled.div`
  background: linear-gradient(0deg,  ${colors.BEESWAX} 0%, ${colors.ENERGY_YELLOW} 100%);
  padding: 20px 0 50px;
  color: ${colors.INTERNATIONAL_ORANGE};
  margin-top: 40px;
  
  @media (max-width: 979px) {
    padding: 20px 0 40px;
    margin-top: 30px;
  }  
`;

const CheckEmailHeader = styled.h3`
  margin-bottom: 60px;
  
   @media (max-width: 979px) {
     margin-bottom: 40px;
   }  
`;
